import React from 'react';
import Select from "react-select";
import { handleChangeId } from "../../../utils/selectBoxFunc";

const PriceSelector = props => {
  return (
    <div className='selectConditions searchList isPriceCategory'>
      <Select
        value={props.items.find(obj => obj.value === props.priceId)}
        options={props.items}
        onChange={e => handleChangeId(e, props.setPriceId)}
        placeholder={''}
      />
    </div>
  )
};

export default PriceSelector;